import { withStyles } from "@material-ui/core";
import { AddRounded as AddRoundedIcon, Edit as EditIcon } from '@material-ui/icons';
import Tooltip from "../../../../../common/StyledToolTip";
import SearchBox from "../../../../../common/SearchBox";
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';
const styles = (theme) => ({
  iconContainer: {
    display: "flex",
    alignItems: "center",
  },
  headerStyle: {
    margin: "5px 0px",
    height: "30px",
    borderRadius: "4px 4px 0 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  headerLabel: {
    color: theme.HeaderSelectedText,
    fontSize: "14px",
    fontWeight: 600,
  },
  headerIconStyles: {
    padding: "5px 10px",
    borderLeft: `1px solid ${theme.AppBGColor}`,
    color: theme.iconColor,
  },
  disableIcon: {
    cursor: "not-allowed",
    opacity: 0.7,
  },
  enableIcon: {
    cursor: "pointer",
  },
  iconLayout: {
    color: theme.iconColor,
    "&>span": {
      padding: "10px 10px",
      color: theme.iconColor,
    },
  },
});

const getIconTitle = (params) => {
  const { iconName, isFormOpened, isDisabled } = params;
  if (isFormOpened) {
    return 'Add/Update in progress';
  }
  switch (iconName) {
    case 'editIcon':
      return isDisabled ? 'Select a single row to edit' : 'Click to edit';
    case 'addIcon':
      return isDisabled ? 'Disabled' : 'Click to add';
    default:
      return '';
  }
};

const RenderHeaderIcon = (params) => {
  const { iconName, isDisabled, isFormOpened, classes } = params;
  const headerIconClasses = `${classes.headerIconStyles} ${classes.iconLayout} ${
    isDisabled ? classes.disableIcon : classes.enableIcon
  }`;
  const title = getIconTitle({ iconName, isDisabled, isFormOpened });
  return (
    <span
      className={headerIconClasses}
      onClick={() => !isDisabled ? params.openForm(params.selectedTerminals, params.terminalInfo) : null}>
      <Tooltip title={title}>{params.icon}</Tooltip>
    </span>
  );
};

const TerminalOnboardGridHeader = ({
  classes,
  gridApi,
  selectedTerminals,
  updateQuickFilterText,
  isTerminalFormOpen: isFormOpened,
  onBoardTerminalFormOpen: openForm
}) => {
  const commonIconProps = {
    openForm,
    isFormOpened,
    classes
  };
  return (
    <div className={classes.headerStyle}>
      <div className={classes.headerLabel} data-automationid="TerminalOnboarding-title">
        Terminal Onboarding
      </div>
      <div className={classes.iconContainer}>
        <span>
          <SearchBox onChange={updateQuickFilterText} />
          <ClearAllFilterButton gridApi={gridApi} />
        </span>
        <RenderHeaderIcon
          isDisabled={!selectedTerminals?.length || isFormOpened || selectedTerminals?.length > 1}
          icon={<EditIcon />}
          iconName="editIcon"
          selectedTerminals={selectedTerminals}
          terminalInfo={selectedTerminals[0]}
          {...commonIconProps}
        />
        <RenderHeaderIcon
          isDisabled={isFormOpened}
          icon={<AddRoundedIcon />}
          iconName="addIcon"
          selectedTerminals={[]}
          terminalInfo={null}
          {...commonIconProps}
        />
      </div>
    </div>
  );
};
export default withStyles(styles)(TerminalOnboardGridHeader);
